import { z } from "zod";
/**
 * Common base schema - shared fields between domain and DTO
 * Contains the core base fields that are common to both representations
 */
export const zBaseCommonSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export const zBaseFiltersSchema = z.object({
    search: z.string().optional(),
});
